import React, { Component, } from 'react'
import PropTypes from 'prop-types'


import Button from 'components/_atoms/Button'

import EventDisplay from './EventDisplay'
import AddLocation from './AddLocation'

import './styles.css'

class EditTrip extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      addTripLocation: PropTypes.func.isRequired,
      viewTrip: PropTypes.func.isRequired,
    }).isRequired,
    tripData: PropTypes.shape({
      events: PropTypes.array,
    }).isRequired,
    tripId: PropTypes.string.isRequired,
  }

  doneEditing = () => {
    const { tripId, } = this.props
    this.props.actions.viewTrip({ tripId, })
  }

  render() {
    const { doneEditing, } = this
    const { tripId, tripData, actions, } = this.props
    const { addTripLocation, } = actions

    return (
      <div className="EditTrip">
        <div>
          {tripData.events.map(event => (
            <EventDisplay
              key={event.id}
              tripId={tripId}
              event={event}
            />)
          )}
        </div>
        <AddLocation
          tripId={tripId}
          tripData={tripData}
          addTripLocation={addTripLocation}
        />
        <div className="done-container">
          <Button onClick={doneEditing}>Finish Editing</Button>
        </div>
      </div>
    )
  }
}

export default EditTrip



// WEBPACK FOOTER //
// ./src/components/EditTrip/index.js